//2024.12.2 Encapsulating server configurations, for easy reading & source code management
import { Client, Functions, Account,Databases, ID, Query, Graphql } from 'appwrite'
import { Storage } from 'appwrite'
//import  reduxStore  from './../../store.js'

class AW_server{  //Appwrite server
    constructor(_ep, _pj) {
        this.endpoint=_ep;
        this.project = _pj;
        this.client = new Client();
        this.client
            .setEndpoint(this.endpoint) // Your API Endpoint
            .setProject(this.project) // Your project ID
        ;
        this.graphql = new Graphql(this.client);
        this.storage = new Storage(this.client);
    }
}

class AW_functions extends AW_server {
    constructor(_ep,_pj){
        super(_ep,_pj);
        //this.account = new Account(this.client);
        this.functions = new Functions(this.client);
    }

    createExecution(funcID){
        let res = this.functions.createExecution(funcID);
        return res;
    }

    getExecution(execID){
        return this.functions.getExecution(execID);
    }

    testGet(){
        console.log('inside AW_functions::testGet()');
        //return;
        alert('AW_functions::testGet called');
        let res = this.functions.createExecution('63b671da8559cbe7e130')
        res.then( (response)=>{
            let logItems = response;
            console.log(logItems);

        })
    }
}


//2024.12.2 UserDepot relies on AppWrite cookie to function: acount.get() is the Appwrite way of user login status check.
class UserDepot extends AW_server {
    constructor(_ep,_pj){
        super(_ep,_pj);
        this.account = new Account(this.client);
    }
    async create(_id, _email, _pw){ return await this.account.create(_id, _email, _pw);}
    async updatePrefs(prefs){
         return await this.account.updatePrefs(prefs)
    }
    async getPrefs(){
         return await this.account.getPrefs()
    }
    async deleteSession(session){  return await this.account.deleteSession(session) }
    async createEmailSession(_email, _pw){
        return await this.account.createEmailPasswordSession(_email,_pw);
    }
    async createVerification(_email,_pw){
        return await this.account.createVerification(_email,_pw);
    }
    async updateVerification(userId,secret){
        return await this.account.updateVerification(userId,secret);
    }

    async createRecovery(email, recovery_url){
        return await this.account.createRecovery(email,recovery_url);
    }

    async updateRecovery(userId, secret, password,password2){
        return await this.account.updateRecovery(userId, secret, password,password2);
    }

    async createJWT(){  //when calling this, it's assumed the user is logged in. No error checking for now.
        const res = await this.account.createJWT();
        return res
    }

    async loginCheck(){
        console.log("loginCheck()!")
        let response
        try{
            response = await this.account.get()
        }catch(error){
            console.log("error:"+error)
            return null
        }
        return response
    }

    getAvatarLink(fileId){
        const bucketId = '676c3e070036f2e4198e';  // ibgMemberPhotos on Appwrite cloud.
        const imageUrl = this.storage.getFileView(bucketId, fileId);
        return imageUrl
    }


}


class AppwriteCloudServer extends AW_server {
    constructor(_ep,_pj){
        super(_ep,_pj);
        this.account = new Account(this.client);
        this.database = new Databases(this.client)

        this.databaseIBG = '675a0d1900214d0c5f3d'  //database ID
        this.collectionProfileCoach = '675a106e002221b4eb34'
        this.collectionProfileStudent = '675b1718061a43dc272b'
        this.collectionTaskPosts = '675f3bc4003ad736cc0a'
        this.collectionVersionChecking = '6776094400267f13db84'
    }

    async createMaticURLToken(email, verificationURL){
        const result =  await this.account.createMagicURLToken( ID.unique(), email, verificationURL );
        return result
    }

    async createSession(userId, secret){
        const result =  await this.account.createSession( userId, secret );
        return result
    }

    //2025.1.2 using GraphQL, retrieve composite data in one HTTP request, replace / obsolete userDepot.loginCheck(), userDepot.getPrefs(), and add ver# data
    async accountFetchGQL(){
        const versionCheckingCollectionId = this.collectionVersionChecking
        const query_string = JSON.stringify([Query.select(["latestVersion"])])
        const batchedGQLQuery = `
                                    query BatchedQueries {
                                        accountGet {
                                            _id
                                            email
                                        }
                                        accountGetPrefs{ data }
                                        databasesListDocuments(databaseId: "${this.databaseIBG}", collectionId: "${versionCheckingCollectionId}", queries: ${query_string}){total documents{_id data}}
                                    }
                                `
        //2025.1.2 Appwrite SDK nitpicking: (double quotes around vars for databaseId/collectionId, but not for queries)
        // work:      databasesListDocuments(databaseId: "${this.databaseIBG}", collectionId: "${versionCheckingCollectionId}", queries:  ${query_string} ){total documents{_id data}}
        // doesn't:   databasesListDocuments(databaseId: "${this.databaseIBG}", collectionId: "${versionCheckingCollectionId}", queries: "${query_string}"){total documents{_id data}}


        const resultPromise = this.graphql.query({ query: batchedGQLQuery });
        try {
          const result = await resultPromise;
          if( !result.data.accountGet ){
              return null
          }
          const accountObject = {email: result.data.accountGet.email }

          const prefs = JSON.parse(result.data.accountGetPrefs.data)
          accountObject['prefs'] = prefs

          const version_object = JSON.parse(result.data.databasesListDocuments.documents[0].data)
          accountObject['appVersionLatest'] = version_object.latestVersion

          return accountObject
        } catch (error) {
          console.error(error);
          return null
        }
    }
/* Sample of fetched data:
                {
                    "accountGet": {
                        "_id": "675b7f8b7bb04c13f1aa",
                        "email": "eliot.teltscher@ibgtennis.com"
                    },
                    "accountGetPrefs": {
                        "data": "{\"userType\":\"coach\",\"locale\":\"zh-CN\",\"avatar\":\"676c4365000597847899\"}"
                    },
                    "databasesListDocuments": {
                        "total": 1,
                        "documents": [
                            {
                                "_id": "6776098200145df6225d",
                                "data": "{\"latestVersion\":\"1.0.24.0101.1\",\"$permissions\":null}"
                            }
                        ]
                    }
                }
*/



    //dev test
    async checkAccountGQL(){

       const versionCheckingCollectionId = this.collectionVersionChecking

        //2025.1.1 discovered trick:  attribute name should be lower case, e.g. "email",  even though on Appwrite console it's displayed as "Email"
        // accountGet attributes can be selected, not other document types (they can only use "data" to return ALL attribute values, JSON.stringified) -- until we make "select" work.
       const query = this.graphql.query({
                                query: `
                                    query BatchedQueries {
                                        accountGet {
                                            _id
                                            email
                                        }
                                        accountGetPrefs{ data }
                                        databasesListDocuments(databaseId: "675a0d1900214d0c5f3d", collectionId: "${versionCheckingCollectionId}"){total documents{_id data}}
                                    }
                                `
                        });

        try {
          const result = await query;
          console.log(result);
          return result
        } catch (error) {
          console.error(error);
        }


    }

    //dev test
    async getPrefsGQL2(){

        const versionCheckingCollectionId = this.collectionVersionChecking
        const coachProfiles =  this.collectionProfileCoach
        const query_string = JSON.stringify([Query.equal('Name', 'Eliot Teltscher')])
        const myQuery = `
                                    query {
                                        databasesListDocuments(  databaseId: "${this.databaseIBG}", collectionId: "${coachProfiles}", queries: ${query_string} )  {
                                            total
                                            documents {
                                                _id
                                               data
                                            }
                                    }
                                    }
                                `

        const myListQuery=`query {accountGet {_id  email }, accountDoc:accountGetPrefs {data}, listDoc: databasesListDocuments(databaseId: "675a0d1900214d0c5f3d", collectionId: "${versionCheckingCollectionId}"){total documents{_id data}}}`

        const myAccountQuery = 'query GetAccount{ accountGet { _id  email name } accountGetPrefs{ data } } '
        try {
         const result = await this.graphql.query({
                                query: myListQuery
                        });
          console.log(result);
          return result
        } catch (error) {
          console.error(error);
        }
    }


    async getPrefsGQL(){



        const query = this.graphql.query({
                                query: `
                                    query {
                                        accountGetPrefs {
                                            data
                                        }
                                    }
                                `
                        });

        try {
          const result = await query;
          console.log(result);
          return result
        } catch (error) {
          console.error(error);
        }
    }

    async updatePrefsGQL(){
         const mutation = this.graphql.mutation({
                query: `
                    mutation UpdatePreferences($prefs: [String: String]!) {
                        accountUpdatePrefs(prefs: $prefs) {
                            prefs
                        }
                    }
                `,
                variables: {
                    prefs: {
                        theme: "dark",
                        language: "en"
                    }
                }
            });

            try {
                const response = await mutation;
                console.log(response);
            } catch (error) {
                console.error(error);
            }
    }

    async createProfile(userType,data){
        return await this.database.createDocument(this.databaseIBG,this.utilCollectionId(userType),ID.unique(), data)
    }

    async updateProfile(userType,docId,data){
        return await this.database.updateDocument(this.databaseIBG,this.utilCollectionId(userType),docId, data)
    }
    
    async loadProfileByEmail(userType, email){
        const results = await this.database.listDocuments(this.databaseIBG,this.utilCollectionId(userType),  [Query.equal('Email', email)])
        if( results['total'] === 0){
            return null
        }else{
            return results['documents'][0]
        }
    }

    async loadProfileListByEmails(userType, emailList){
        const results = await this.database.listDocuments(this.databaseIBG,this.utilCollectionId(userType),  [Query.equal('Email', emailList)])
        if( results['total'] === 0){
            return null
        }else{
            return results['documents']
        }
    }



     async loadProfileByEmailGQL(userType, email){
       const collectId = this.utilCollectionId(userType);
       const myQuery = `
                                    query {
                                        databasesListDocuments(  databaseId: "${this.databaseIBG}", collectionId: "${collectId}") 
                                            {
                                            total
                                            documents{
                                                _id
                                            }
                                        }
                                    }
                                `

       const query2 = this.graphql.query({
                                query: `query {
                                        databasesListDocuments(  databaseId: "${this.databaseIBG}", collectionId: "${collectId}")  {
                                            total
                                            documents {
                                                _id
                                               data
                                            }
                                        }
                                     }
                                `
                        });


//queries: ["equal('Name', 'JJC')"]
        const myTQuery = "query {accountGetPrefs {    data  }}"
        const myListQuery = `query {accountDoc:accountGetPrefs {    data  }, listDoc: databasesListDocuments(databaseId: "675a0d1900214d0c5f3d",  collectionId: "675b1718061a43dc272b", ){total documents{_id Name}}}`
        const myListEdit = `query {editDoc: databasesEditDocument(databaseId: "675a0d1900214d0c5f3d",  collectionId: "675b1718061a43dc272b", documentId:"675b6a58003293b4dcbc",Name:"NewName") {_id} }`
        const query = this.graphql.mutation({
                                 query: myListEdit
                                }
                        );


        try {
          const results = await query;
          console.log(results);
          return results
        } catch (error) {
          console.error(error);
        }

        if( results['total'] === 0){
            return null
        }else{
            return results['documents'][0]
        }
    }


    async loadProfileList(userType){
        const results = await this.database.listDocuments(this.databaseIBG,this.utilCollectionId(userType))
        return results['documents']
        //2024.12.13 todo: add error handling.
    }

    utilCollectionId(userType){
        const collectionID = userType === 'coach' ? this.collectionProfileCoach : this.collectionProfileStudent;
        return collectionID
    }

    async createPost(data){
        const results = await this.database.createDocument(this.databaseIBG,this.collectionTaskPosts, ID.unique(), data)
        return results
    }

   async updatePost(docId, data){
        const results = await this.database.updateDocument(this.databaseIBG,this.collectionTaskPosts, docId, data)
        return results
    }

   async deletePost(docId){
        const results = await this.database.deleteDocument(this.databaseIBG,this.collectionTaskPosts, docId)
        return results
    }

    async loadPostList(emailFilter, filter, pageSize=100, pageNum=1){
        let query=[]
        if( emailFilter){
            query=[Query.equal("userId", emailFilter )]
        }else if(filter==='all'){
              //query=[];
              query = [Query.equal("AllowedViewers", 'coachGroup' )];
        }else  if(filter==='ibg24camp'){
            //query=[Query.contains("AllowedViewers", filter )]
            query=[Query.equal("AllowedViewers", 'ibg24camp' )]
        }else {
            console.log("Dev Warning!! going beyond hard coded, Unhandled cases!")
            query=[Query.equal("AllowedViewers", filter )]
        }

        query = [...query, Query.orderDesc('createTimestamp'), Query.offset(pageSize*(pageNum - 1)), Query.limit(pageSize)]
        //query = [...query, Query.isNull("parentId")]      //2024.12.29: load only main thread posts, not follow-up/reply posts
        query = [...query, Query.or([Query.isNull("parentId"), Query.equal("parentId", "")])]      //2024.12.29: load only main thread posts, not follow-up/reply posts -- isNull() doesn't work? heck.
        const results = await this.database.listDocuments(this.databaseIBG,this.collectionTaskPosts, query)
        return results
        //2024.12.15 todo: add error handling.
    }

    async loadOnePost(postId){
        let query=[]
        if( postId){
            query=[Query.equal("$id", postId )]
        }else{
            alert("Error! MyAppServerDefs::loadOnePost() called without valid id argument")
            return null
        }
        const results = await this.database.listDocuments(this.databaseIBG,this.collectionTaskPosts, query)
        if(results.total < 1 ){
            alert(`No documents for ${postId}!`)
            return null
        }
        return results['documents'][0]
        //2024.12.15 todo: add error handling.
    }

    async loadRepliesOfOnePost(parentPostId){
        if( !parentPostId) return []
        const query=[Query.equal("parentId", parentPostId )]
        const results = await this.database.listDocuments(this.databaseIBG,this.collectionTaskPosts, query)
         //future todo:  handle pagination.
        return results['documents']
    }

   //"children" means reply posts: each is a "child" of the main post.
   async countPostChildren(parentPostId){
       if( !parentPostId) {
           return 0
       }
        const query=[Query.equal("parentId", parentPostId ), Query.limit(1)]
        const results = await this.database.listDocuments(this.databaseIBG,this.collectionTaskPosts, query)
        //todo: add error checking.
        return results['total']
   }

    //2025.3.4 upload a file to Appwrite storage. return info:
    /*
    $createdAt:"2025-03-04T23:42:23.216+80:8

    $id:"67c78fdd0027d40b6855"

    $permissions:(3)['read("user:67b74f4700
    $updatedAt:"2025-03-04T23:42:23.216+00:8

    bucketId:"67c78cfb001915187abb"

    chunksTotal:1
    chunksUploaded:1
    mimeType:"application/vnd.openxmlformats
    name: "testDoc.docx"
    signature:"a9e723592c8ed3749e0501d39a782
    size0riginal: 13513

    */

    //https://cloud.appwrite.io/v1/storage/buckets/{bucketId}/files/{fileId}/view?project={projectId}
    //https://cloud.appwrite.io/v1/storage/buckets/67c78cfb001915187abb/files/67c78fdd0027d40b6855/view?project=674dc69f000727ccc93b

    //storage.getFileView():  generate a URL for accessing a file in storage
    // getFileDownload - Generates a URL to force a file download
    //getFilePreview - Generates a URL for image previews
    // storage.deleteFile()
    async uploadFileToAppwriteCloud(fileObject){
        const Tier1IBG_CoachingFiles_bucket_id = '67c78cfb001915187abb'
        const results = await this.storage.createFile(
            Tier1IBG_CoachingFiles_bucket_id,
            ID.unique(),
            fileObject,
            )
        return results
    }

    uploadedFileURLS( fileId){
        const Tier1IBG_CoachingFiles_bucket_id = '67c78cfb001915187abb'
        const urlFileView =     this.storage.getFileView(Tier1IBG_CoachingFiles_bucket_id, fileId);
        const urlFilePreview =  this.storage.getFilePreview(Tier1IBG_CoachingFiles_bucket_id, fileId);
        const urlFileDownload = this.storage.getFileDownload(Tier1IBG_CoachingFiles_bucket_id, fileId);
        return {urlFileView, urlFilePreview, urlFileDownload}
    }


}





class OSSNCloudServer {
    constructor(hostConfig){
        this.site = hostConfig.host;
        this.api_key_token = hostConfig.api_key_token;

        //ep: endpoints.
        this.ep_user_auth       =   this.site + '/api/v1.0/user_authenticate'
        this.ep_user_details    =   this.site + '/api/v1.0/user_details'
        this.ep_group_post_list =   this.site + '/api/v1.0/wall_list_group'
    }


    async myFetch(url){
          try {
                const response = await fetch(url);
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                console.log(data);
                return data
          } catch (error) {
            console.error(error);
                return {error: 'error'}
          }
    }

    //https://www.mywebsite.com/api/v1.0/wall_list_group
    async groupListAllPosts(gid, uid){
        const fetch_url = this.ep_group_post_list + `?api_key_token=${this.api_key_token}&group_guid=${gid}&guid=${uid}`  // error:  offet / count either one causes error. &offset=0&count=10`
        return await this.myFetch(fetch_url);
    }

    async userAuth(username, password) {
        const fetch_url = this.ep_user_auth + `?api_key_token=${this.api_key_token}&username=${username}&password=${password}`
        return await this.myFetch(fetch_url);
    }

    //2025.1.20 fater wasting a couple of hours:  POST does not work. GET does.
    async userAuthPost(username, password) {

        const fetch_payload =    {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                //'api_key_token': this.api_key_token,
              },
              body: JSON.stringify({api_key_token: this.api_key_token, username,password })
            }

        try {
            const response = await fetch(this.ep_user_auth, fetch_payload);
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            console.log(data);
            return data
      } catch (error) {
        console.error(error);
      }
    }


    async userDetails(uid){
        const fetch_url = this.ep_user_details + `?api_key_token=${this.api_key_token}&guid=${uid}`
        return await this.myFetch(fetch_url);
    }


};


export {AW_server,UserDepot, AppwriteCloudServer, OSSNCloudServer}
